import { createAsyncThunk } from "@reduxjs/toolkit";
import { logoutUser } from "./authThunks";

const API_BASE = process.env.REACT_APP_API_BASE;
/**
 * fetch all Members entries
 */
export const fetchMemberReferralsItems = createAsyncThunk(
  "memberreferrals/fetchItems",
  async (_, thunkAPI) => {
    const res = await fetch(`${API_BASE}/api/memberreferrals`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "vendor",
      },
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
       window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const fetchMemberReferralByID = createAsyncThunk(
  "referrals/fetchById",
  async (ReferralId, thunkAPI) => {
    const res = await fetch(
      `${API_BASE}/api/memberreferrals/getByParam?referral_id=${ReferralId}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "vendor",
        },
      }
    );
    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
       window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();

    if (!res.ok) {
      throw new Error(json?.message || "Fetch failed");
    }

    return json;
  }
);
